import resume from './assets/resume.pdf'

const header = {
  // all the properties are optional - can be left empty or deleted
  title: 'AB.',
  homepage: 'https://albonec.github.io/portfolio-website',
}

const en = {
  about: {
    name: 'Alessandro',
    role: "Modern problems require modern solutions. I'm dedicated to making those happen.",
    description: '',
    resume,
    social: {
      linkedin: 'https://www.linkedin.com/in/alessandro-bonecchi-42999b275/',
      github: 'https://github.com/albonec',
    },
  },
  projects: [
    {
      name: 'Schema',
      description:
        'The end-to-end AI-Native EDA software hardware engineers need.',
      stack: ['  ', '  '],
      livePreview: 'https://theaieda.com/schema',
    },
    {
      name: 'LoWo',
      description:
        'Snippet Manager for programmers, students, and creatives alike!',
      stack: ['React', 'Express', 'TypeScript', 'MongoDB'],
      sourceCode: 'https://github.com/jightning/lowo',
      livePreview: 'https://lowo-six.vercel.app/',
    },
    {
      name: 'FOSSMetronome',
      description: 'Simple open-source Android metronome app for musicians.',
      stack: ['Java', 'Kotlin', 'Android'],
      sourceCode: 'https://github.com/albonec/FOSSMetronome',
    },
    {
      name: 'Traduttore Dialettico',
      description:
        'Translator web app for taking standard Italian and translating it into local dialects.',
      stack: ['React', 'Tailwind', 'NLP'],
      sourceCode: 'https://github.com/albonec/traduttore-dialetto/',
      livePreview: 'https://traduttore-dialetto.vercel.app/',
    },
  ],
  skills: [
    'Python',
    'Java',
    'Rust',
    'C',
    'C++',
    'JavaScript',
    'SQL',
    'HTML',
    'CSS',
    'Android',
    'Git',
    'Flask',
    'Node.js',
    'React.js',
    'Next.js',
    'Express.js',
    'MongoDB',
    'SQLite',
    'AWS',
    'Docker',
    'TensorFlow',
    'PyTorch',
    'Keras',
    'NumPy',
    'OpenCV',
    'wxWidgets',
    'Qt',
    'Generative AI',
    'AI Agents',
    'Prompt Engineering',
    'Machine Learning',
    'Computer Vision',
    'Cybersecurity',
    'Cryptography',
    'LangGraph'
  ],
  contact: {
    description: "Let's get in touch and build something together!",
  },
  experience: [
    {
      company: 'The AI EDA Corporation',
      position: 'Co-Founder/Chief Technical Officer',
      duration: 'Sep 2026 - Present',
      description:
        "Building Schema, the fully AI-Native end-to-end electronic hardware design suite. Schema lets hardware designers and engineers go from idea to buuldable hardware, all in natural language.",
    },
    {
      company: 'Meta',
      position: 'Open Source Developer',
      duration: 'Jun 2026 - Aug 2026',
      description:
        "Contributing Rust production code, usage examples, and API design changes to Meta's Auditable Key Directory (AKD), a cryptographic key transparency library, and shipping fixes for data and identity-leak vulnerabilities.",
    },
    {
      company: 'Purdue Aerial Robotics',
      position: 'Software Engineer',
      duration: 'Aug 2025 - May 2026',
      description:
        'Building real-time computer vision software in Python and Rust on an NVIDIA Jetson Nano for autonomous aerial vehicles, with IPC-based data streaming between onboard processes and Docker containerization.',
    },
    {
      company: "Rove Miles (YC '24)",
      position: 'Software Engineering Intern',
      duration: 'Jun 2025 - Aug 2025',
      description:
        'Built and presented a full-stack travel-rewards web app in six weeks using Python, Flask, SQLite, and JavaScript, featuring a 10,000+ entry database, an interactive airline-route map, and FFI-powered value-per-mile analytics.',
    }
  ],
  translations: {
    projects: 'Projects',
    experience: 'Experience',
    skills: 'Skills',
    contact: 'Contact',
    resume: 'Resume',
    submit: 'Submit',
    namePlaceholder: 'Name',
    emailPlaceholder: 'Email',
    messagePlaceholder: 'Message',
    submitSuccess: 'Submission successful! Thank you for reaching out!',
    submitError: 'An error occurred',
    madeWith: 'Made with 💖 by Alessandro Bonecchi',
    greeting: "Hello! I'm",
  }
}

const it = {
  about: {
    name: 'Alessandro',
    role: "Problemi moderni richiedono soluzioni moderne. Mi dedico a realizzarle.",
    description: '',
    resume,
    social: en.about.social,
  },
  projects: [
    {
      name: 'Schema',
      description:
        'Il software EDA end-to-end AI-Native di cui gli ingegneri hardware hanno bisogno.',
      livePreview: 'https://theaieda.com/schema',
    },
    {
      name: 'LoWo',
      description:
        'Snippet Manager per programmatori, studenti e creativi!',
      stack: ['React', 'Express', 'TypeScript', 'MongoDB'],
      sourceCode: 'https://github.com/jightning/lowo',
      livePreview: 'https://lowo-six.vercel.app/',
    },
    {
      name: 'FOSSMetronome',
      description: 'Semplice app metronomo open-source per musicisti su Android.',
      stack: ['Java', 'Kotlin', 'Android'],
      sourceCode: 'https://github.com/albonec/FOSSMetronome',
    },
    {
      name: 'Traduttore Dialettico',
      description:
        "Web app per tradurre l'italiano standard in dialetti locali.",
      stack: ['React', 'Tailwind', 'NLP'],
      sourceCode: 'https://github.com/albonec/traduttore-dialetto/',
      livePreview: 'https://traduttore-dialetto.vercel.app/',
    },
  ],
  skills: en.skills,
  contact: {
    description: "Mettiamoci in contatto e costruiamo qualcosa insieme!",
  },
  experience: [
    {
      company: 'The AI EDA Corporation',
      position: 'Co-Fondatore/Direttore Tecnico',
      duration: 'Set 2026 - Presente',
      description:
        "Sviluppo Schema, la suite di progettazione hardware elettronico end-to-end completamente AI-Native. Schema permette a progettisti e ingegneri hardware di passare dall'idea a hardware realizzabile, tutto in linguaggio naturale.",
    },
    {
      company: 'Meta',
      position: 'Sviluppatore Open Source',
      duration: 'Giu 2026 - Ago 2026',
      description:
        "Contribuisco codice di produzione in Rust, esempi d'uso e modifiche all'API di Auditable Key Directory (AKD) di Meta, una libreria crittografica di key transparency, con correzioni per vulnerabilità di fuga di dati e identità.",
    },
    {
      company: 'Purdue Aerial Robotics',
      position: 'Ingegnere del Software',
      duration: 'Ago 2025 - Mag 2026',
      description:
        'Sviluppo software di computer vision in tempo reale in Python e Rust su un NVIDIA Jetson Nano per veicoli aerei autonomi, con streaming di dati via IPC tra i processi di bordo e containerizzazione con Docker.',
    },
    {
      company: "Rove Miles (YC '24)",
      position: 'Ingegnere del Software Stagista',
      duration: 'Giu 2025 - Ago 2025',
      description:
        'Ho costruito e presentato in sei settimane una web app full-stack per premi di viaggio con Python, Flask, SQLite e JavaScript, con un database di oltre 10.000 voci, una mappa interattiva delle rotte aeree e analisi valore-per-miglio tramite FFI.',
    }
  ],
  translations: {
    projects: 'Progetti',
    experience: 'Esperienza',
    skills: 'Competenze',
    contact: 'Contatta',
    resume: 'Curriculum Vitae',
    submit: 'Invia',
    namePlaceholder: 'Nome',
    emailPlaceholder: 'Email',
    messagePlaceholder: 'Messaggio',
    submitSuccess: 'Invio riuscito! Grazie per avermi contattato!',
    submitError: 'Si è verificato un errore',
    madeWith: 'Fatto con 💖 da Alessandro Bonecchi',
    greeting: "Ciao! mi chiamo",
  }
}

const es = {
  about: {
    name: 'Alessandro',
    role: 'Problemas modernos requieren soluciones modernas. Me dedico a crearlas.',
    description: '',
    resume,
    social: en.about.social,
  },
  projects: [
    {
      name: 'Schema',
      description:
        'El software EDA end-to-end AI-Native que necesitan los ingenieros de hardware.',
      livePreview: 'https://theaieda.com/schema',
    },
    {
      name: 'LoWo',
      description:
        '¡Administrador de snippets para programadores, estudiantes y creativos!',
      stack: ['React', 'Express', 'TypeScript', 'MongoDB'],
      sourceCode: 'https://github.com/jightning/lowo',
      livePreview: 'https://lowo-six.vercel.app/',
    },
    {
      name: 'FOSSMetronome',
      description:
        'Sencilla app de metrónomo open-source para músicos en Android.',
      stack: ['Java', 'Kotlin', 'Android'],
      sourceCode: 'https://github.com/albonec/FOSSMetronome',
    },
    {
      name: 'Traduttore Dialettico',
      description:
        'Aplicación web que traduce el italiano estándar a dialectos locales.',
      stack: ['React', 'Tailwind', 'NLP'],
      sourceCode: 'https://github.com/albonec/traduttore-dialetto/',
      livePreview: 'https://traduttore-dialetto.vercel.app/',
    },
  ],
  skills: en.skills,
  contact: {
    description: '¡Pongámonos en contacto y construyamos algo juntos!',
  },
  experience: [
    {
      company: 'The AI EDA Corporation',
      position: 'Cofundador/Director de Tecnología',
      duration: 'Sep 2026 - Presente',
      description:
        'Desarrollo Schema, la suite de diseño de hardware electrónico end-to-end totalmente AI-Native. Schema permite a diseñadores e ingenieros de hardware pasar de la idea a hardware fabricable, todo en lenguaje natural.',
    },
    {
      company: 'Meta',
      position: 'Desarrollador Open Source',
      duration: 'Jun 2026 - Ago 2026',
      description:
        'Contribuyo código de producción en Rust, ejemplos de uso y cambios de diseño de API al Auditable Key Directory (AKD) de Meta, una biblioteca criptográfica de transparencia de claves, además de correcciones para vulnerabilidades de fuga de datos e identidad.',
    },
    {
      company: 'Purdue Aerial Robotics',
      position: 'Ingeniero de Software',
      duration: 'Ago 2025 - May 2026',
      description:
        'Desarrollo software de visión por computadora en tiempo real en Python y Rust sobre una NVIDIA Jetson Nano para vehículos aéreos autónomos, con transmisión de datos vía IPC entre procesos a bordo y contenedores de Docker.',
    },
    {
      company: "Rove Miles (YC '24)",
      position: 'Pasante de Ingeniería de Software',
      duration: 'Jun 2025 - Ago 2025',
      description:
        'Construí y presenté en seis semanas una aplicación web full-stack de recompensas de viaje con Python, Flask, SQLite y JavaScript, con una base de datos de más de 10,000 entradas, un mapa interactivo de rutas aéreas y análisis de valor por milla mediante FFI.',
    },
  ],
  translations: {
    projects: 'Proyectos',
    experience: 'Experiencia',
    skills: 'Habilidades',
    contact: 'Contacto',
    resume: 'Currículum',
    submit: 'Enviar',
    namePlaceholder: 'Nombre',
    emailPlaceholder: 'Correo electrónico',
    messagePlaceholder: 'Mensaje',
    submitSuccess: '¡Envío exitoso! ¡Gracias por contactarme!',
    submitError: 'Ocurrió un error',
    madeWith: 'Hecho con 💖 por Alessandro Bonecchi',
    greeting: '¡Hola! Soy',
  },
}

export { header, en, it, es }
